import { createAction } from "typesafe-actions";
import { User } from "@app/types/interfaces";

const LOG_OUT = "[Auth] Log Out";
const SET_USER = "[Auth] Set User";

export const LogOut = createAction(LOG_OUT)<void>();
export const SetUser = createAction(SET_USER, (user: User) => user)<User>();
